import { Button } from '../../../../../../components/Toolkit/Button/Button';
import { type RevealPhoneNumberProps } from '../../../../../../components/PageWrappers/SharedComponents/RevealPhoneNumber/RevealPhoneNumber';
import { ShowNumberBottomSheet } from '../subcomponents/ShowNumberBottomSheet';
import { EmailDealerOrSeller } from '../../EmailDealerOrSeller/EmailDealerOrSeller';

import { type EmailDealerOrSellerProps } from '../../EmailDealerOrSeller/EmailDealerOrSeller.typed';
import { MailOutlineIc } from '@dsch/dd-icons';

import { useWhatsappAction } from '../subcomponents/useWhatsAppAction';

import styled from 'styled-components';

type Variant1Props = {
  displayContactDealershipBottomSheet: boolean;
  phoneResponse: boolean;
  emailResponse: boolean;
  phoneContactProps: RevealPhoneNumberProps;
  emailSellerProps: EmailDealerOrSellerProps;
  whatsappResponse: boolean;
  adId: number;
  priceEuro?: number | null;
  sellerType?: string;
  sectionName?: string;
  price?: string | null;
};

const Variant1Container = styled.div<{ ctaCount: number }>`
  display: grid;
  gap: 8px;
  grid-template-columns: ${({ ctaCount }) =>
    `${'min-content '.repeat(Math.max(ctaCount - 1, 0)).trim()} 1fr`};
`;

const SEmailDealerOrSeller = styled(EmailDealerOrSeller)<{ ctaCount: number }>`
  padding: ${({ theme }) => `0 ${theme.spacing.S12}`};
  ${({ ctaCount }) => ctaCount === 2 && `min-width: 124px;`}
`;

const SWhatsappButton = styled(Button)<{ ctaCount: number }>`
  padding: ${({ theme }) => `0 ${theme.spacing.S12}`};
  ${({ ctaCount }) => ctaCount === 2 && `min-width: 124px;`}
`;

const Variant1 = (props: Variant1Props) => {
  const {
    emailResponse,
    emailSellerProps,
    phoneResponse,
    phoneContactProps,
    whatsappResponse,
    adId,
    priceEuro,
    sellerType,
    sectionName,
    price,
  } = props;

  const { onWhatsAppButtonClick, isLoading } = useWhatsappAction({
    adId,
    priceEuro,
    sellerType,
    sectionName,
    price,
  });

  const ctaCount = [phoneResponse, emailResponse, whatsappResponse].filter(
    Boolean,
  ).length;

  return (
    <Variant1Container ctaCount={ctaCount}>
      {emailResponse && (
        <SEmailDealerOrSeller
          {...emailSellerProps}
          ofType={phoneResponse || whatsappResponse ? 'SECONDARY' : 'PRIMARY'}
          ctaCount={ctaCount}
        >
          {ctaCount === 3 ? <MailOutlineIc width={20} height={20} /> : 'Email'}
        </SEmailDealerOrSeller>
      )}
      {whatsappResponse && (
        <SWhatsappButton
          ofType={phoneResponse ? 'SECONDARY' : 'PRIMARY'}
          onClick={onWhatsAppButtonClick}
          disabled={isLoading}
          ctaCount={ctaCount}
        >
          WhatsApp
        </SWhatsappButton>
      )}
      {phoneResponse && (
        <ShowNumberBottomSheet
          // resets internal values on client-side navigation between listings
          key={phoneContactProps.adId}
          {...phoneContactProps}
        >
          Show phone
        </ShowNumberBottomSheet>
      )}
    </Variant1Container>
  );
};

export { Variant1 };
